@if (form) {
  <div [formGroup]="form" class="modalForm">
    <div class="flex flex-column gap-2 mb-3">
      <label for="label" class="font-semibold w-full"
        >{{ "fault_allocation.controller_catalog.model_form.label" | translate }}*</label
      >
      <input pInputText id="label" formControlName="label" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="faultList" class="font-semibold w-full"
        >{{ "fault_allocation.controller_catalog.model_form.fault_list" | translate }}*</label
      >

      <p-select
        appendTo="body"
        [options]="faultLists()"
        optionValue="id"
        formControlName="faultList"
        class="w-full"
        id="faultList"
        [filter]="true"
        filterMatchMode="contains"
        [emptyFilterMessage]="translate.instant('common.no_results_found')"
      />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="notes" class="font-semibold w-full">{{
        "fault_allocation.controller_catalog.model_form.notes" | translate
      }}</label>
      <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true" id="notes"></textarea>
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button [buttonText]="translate.instant('common.cancel')" (click)="closeDialog()"></app-button>
      <app-button
        [buttonText]="translate.instant('common.save')"
        [disabled]="!form.valid"
        (click)="save()"
      ></app-button>
    </div>
  </div>
}
